import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { HubItemFacade } from '../../../hub/item';
import { CompartmentOverview, CompartmentSapModel } from '../../models';
import {
  CompartmentOverviewInitialState,
  CompartmentOverviewLoad,
  CompartmentOverviewUpdate,
  SetInitialErrorState,
} from './compartment-overview.actions';
import { CompartmentOverviewState } from './compartment-overview.state';

@Injectable({ providedIn: 'root' })
export class CompartmentOverviewFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(CompartmentOverviewState.getLoaded);
  name$: Observable<string> = this.store.select(CompartmentOverviewState.getName);
  error$: Observable<boolean> = this.store.select(CompartmentOverviewState.getError);
  overview$: Observable<CompartmentOverview> = this.store.select(CompartmentOverviewState.getOverview);
  compartmentSapClientViews$: Observable<CompartmentSapModel[]> = this.store.select(
    CompartmentOverviewState.getCompartmentSapClientViews,
  );

  constructor(private store: Store, private hubItemFacade: HubItemFacade) {}

  loadAll(compartmentId: number): void {
    // todo: callback for hubId
    this.hubItemFacade.hubId$
      .pipe(take(1))
      .subscribe((hubId: number) => this.store.dispatch(new CompartmentOverviewLoad({ compartmentId, hubId })));
  }

  loadByParams(compartmentId: number, hubId: number): void {
    this.store.dispatch(new CompartmentOverviewLoad({ compartmentId, hubId }));
  }

  getOverviewSnapshot(): CompartmentOverview | null {
    return this.store.selectSnapshot(CompartmentOverviewState.getOverview);
  }

  setInitialState(): void {
    this.store.dispatch(new CompartmentOverviewInitialState());
  }

  setInitialErrorState(): void {
    this.store.dispatch(new SetInitialErrorState());
  }

  updateCompartment(compartmentOverview: CompartmentOverview, listRefreshNeeded?: boolean): void {
    this.hubItemFacade.hubId$.pipe(take(1)).subscribe((hubId: number) =>
      this.store.dispatch(
        new CompartmentOverviewUpdate({
          hubId,
          compartmentOverview,
          listRefreshNeeded,
        }),
      ),
    );
  }
}
